export default __webpack_public_path__ + "static/media/logo-error.7fc6eaec.svg";